import { SortBy } from '@portals/sip-client-data/src/general/ApiClientTypes';
import { ConfigProvider } from '@portals/sip-client-data/src/general/Config';
import { TFunction } from 'i18next';
import { find, get } from 'lodash-es';

type OptionProps = {
  value: SortBy;
  label: string;
};

export const getSortByOptions = (t: TFunction): OptionProps[] => {
  // TODO: REMOVE AFTER IMMOBILIEN API INTEGRATION: switch
  const useImmobilienApi = ConfigProvider.getConfig().get('USE_IMMOBILIEN_API') === 'true';

  const options = [
    {
      value: SortBy.DISTANCE_SMALLEST,
      label: t('sortOptions.distanceSmallest'),
    },
    {
      value: SortBy.PRICE_LOWEST,
      label: t('sortOptions.priceLowest'),
    },
    {
      value: SortBy.PRICE_HIGHEST,
      label: t('sortOptions.priceHighest'),
    },
    {
      value: SortBy.PROPERTY_NEWEST,
      label: t('sortOptions.propertyNewest'),
    },
  ];

  if (!useImmobilienApi) {
    return [
      {
        value: SortBy.INSTITUTE_PRIORITY_HIGHEST,
        label: t('sortOptions.institutePriorityHighest'),
      },
      ...options,
    ];
  }

  return options;
};

export const getSortByLabelFromOptionsByValue = (t: TFunction, value: SortBy): string => {
  const selectedOption = find(getSortByOptions(t), { value });
  return get(selectedOption, 'label', '');
};
